import { IAppState } from '@state/types';

export const getBrands = (state: IAppState): any | undefined => state.brands.brands;

export const getBrand = (state: IAppState): any | undefined => state.brands.brand;

export const getBrandResponse = (state: IAppState): any | undefined => state.brands.brandResponse;

export const getBrandSearch = (state: IAppState): any | undefined => state.brands.brandSearches;

export const getBrandFavoriteResponse = (state: IAppState): any | undefined => state.brands.brandFavoriteResponse;

export const getCounterBrands = (state: IAppState): any | undefined => state.brands.counterBrands;

export const getBrandName = (state: IAppState): any | undefined => state.brands.brandNameResponse;

export const getAddUpdateBrand = (state: IAppState): any | undefined => state.brands.addUpdateResponse;

export const getAddUpdateBrandsnackBar = (state: IAppState): any | undefined => state.brands.addUpdateResponseSnackbar;

export const getMoveFileResponse = (state: IAppState): any | undefined => state.brands.moveFileResponse;

export const getdeletedBrand = (state: IAppState): any | undefined => state.brands.deletedBrand;
